// extracted by mini-css-extract-plugin
export default {"button":"ThinButton_button__FvKTR","small":"ThinButton_small__0HPJ-","inverse":"ThinButton_inverse__PNvE1"};